import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { RegistrationResultModel } from "../models/registration/registration-result.model";
import { RegistrationModel } from "../models/registration/registration.model";
import { RegistrationLinkModel } from "../models/registration-link/registration-link.model";
import { RegistrationFieldConfigModel } from "../models/registration-field-configs/registration-field-config.model";

@Injectable({
    providedIn: 'root'
})
export class RegistrationService {
    private httpClient: HttpClient;
    
    constructor(private httpBackend: HttpBackend) {
        this.httpClient = new HttpClient(httpBackend);
    }

    public register(registrationKey: string, registrationModel: RegistrationModel): Observable<RegistrationResultModel> {
        return this.httpClient.post<RegistrationResultModel>(
            Configuration.getApiBaseUrl() + "/registration/" + registrationKey + "/register", 
            registrationModel
        );
    }

    public getRegistrationLink(registrationKey: string): Observable<RegistrationLinkModel> {
        return this.httpClient.get<RegistrationLinkModel>(
            Configuration.getApiBaseUrl() + "/registration/" + registrationKey 
        );
    }

    public getOrganisationUnitFooter(registrationKey: string): Observable<string> {
        return this.httpClient.get(
            Configuration.getApiBaseUrl() + "/registration/" + registrationKey + '/footer',
            { responseType: 'text' }
        );
    }

    public getOrganisationUnitLogoUrl(registrationKey: string): Observable<string> {
        return this.httpClient.get(
            Configuration.getApiBaseUrl() + "/registration/" + registrationKey + '/logo',
            { responseType: 'text' }
        );
    }

    public getRegistrationLinkFieldConfigs(
        id: string
    ): Observable<RegistrationFieldConfigModel[]> {
        return this.httpClient.get<RegistrationFieldConfigModel[]>(
            Configuration.getApiBaseUrl() + "/registration/" + id + "/field-configs"
        );
    }
}